import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import {
  SET_CC_ALL,
  SET_CC_TEXT_SIZE,
  SET_CC_TEXT_COLOR,
  SET_CC_TEXT_TYPE,
  SET_CC_TEXT_OPACITY,
  SET_CC_TEXT_SHADOW,
  SET_CC_TEXT_SHADOW_COLOR,
  SET_CC_BACKGROUND_COLOR,
  SET_CC_BACKGROUND_OPACITY,
  SET_CC_WINDOW_COLOR,
  SET_CC_WINDOW_OPACITY,
} from 'actions/closedCaptionSettings';

const INITIAL_STATE = Immutable({
  textSize: 'md',
  textColor: 'white',
  textType: 'courier',
  textOpacity: 'solid',
  textShadow: 'none',
  textShadowColor: 'black',
  backgroundColor: 'black',
  backgroundOpacity: 'solid',
  windowColor: 'black',
  windowOpacity: 'transparent',
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_CC_ALL:
      return action.payload ? state.merge(action.payload) : INITIAL_STATE;
    case SET_CC_TEXT_SIZE:
      return state.merge({
        textSize: action.payload,
      });
    case SET_CC_TEXT_COLOR:
      return state.merge({
        textColor: action.payload,
      });
    case SET_CC_TEXT_TYPE:
      return state.merge({
        textType: action.payload,
      });
    case SET_CC_TEXT_OPACITY:
      return state.merge({
        textOpacity: action.payload,
      });
    case SET_CC_TEXT_SHADOW:
      return state.merge({
        textShadow: action.payload,
      });
    case SET_CC_TEXT_SHADOW_COLOR:
      return state.merge({
        textShadowColor: action.payload,
      });
    case SET_CC_BACKGROUND_COLOR:
      return state.merge({
        backgroundColor: action.payload,
      });
    case SET_CC_BACKGROUND_OPACITY:
      return state.merge({
        backgroundOpacity: action.payload,
      });
    case SET_CC_WINDOW_COLOR:
      return state.merge({
        windowColor: action.payload,
      });
    case SET_CC_WINDOW_OPACITY:
      return state.merge({
        windowOpacity: action.payload,
      });
    default:
      return state;
  }
};
